import styled from "styled-components";

export const ModernContainer = styled.main`
  font-family: "Pretendard";
  .info {
    font-family: "Pretendard";
    text-transform: uppercase;
    max-width: 1240px;
    padding: 0 20px;
    width: 100%;
    margin: 0 auto 64px;
    strong {
      font-weight: 700;
      font-size: 50px;
    }
    p {
      color: #666;
      margin-top: 20px;
      font-size: 22px;
    }
  }
  .inner {
    padding: 0 20px;
    width: 100%;
    margin: 0 auto;
    font-size: 20px;
    position: relative;
    max-width: 1240px;
  }
  .bar {
    width: 1px;
    background: #000;
  }
  .introduce {
    .inner {
      max-width: 1200px;
      height: 450px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      position: relative;
      margin: 100px auto 250px;
    }
    .company {
      padding-top: 300px;
      text-align: center;
      .bar {
        margin: auto;
        &:first-child {
          height: 279px;
        }
      }
      span {
        cursor: pointer;
        display: block;
        margin-top: 22px;
      }
    }
  }
  .products {
    margin: 100px 0;
    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 56px;
    }
    .item {
      border-radius: 15px;
      width: calc((100% - 112px) / 3);
      cursor: pointer;
      transition: 0.3s;
      padding: 20px;
      &:hover {
        box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
      }
      img {
        width: 100%;
        aspect-ratio: 3 / 2;
        object-fit: contain;
        border-radius: 15px;
      }
      span {
        display: block;
        &:nth-of-type(1) {
          font-size: 14px;
          font-weight: 300;
          margin: 25px 0 10px;
        }
        &:nth-of-type(2) {
          font-size: 20px;
          font-weight: 600;
        }
      }
    }
  }
  .portfolio {
    .grid {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      width: auto;
      gap: 40px;
    }
    .column {
      background-clip: padding-box;
      div {
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        img,
        .bg {
          width: 100%;
          height: 100%;
          object-fit: cover;
          background: #f6f6f6;
        }
        p {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          background: #fff;
          border-radius: 5px;
          width: calc(100% - 40px);
          padding: 20px;
          span {
            display: block;
            &:nth-of-type(1) {
              font-size: 14px;
              font-weight: 300;
              margin-bottom: 10px;
            }
            &:nth-of-type(2) {
              font-size: 20px;
              font-weight: 600;
            }
          }
        }
        &:not(:last-child) {
          margin-bottom: 40px;
        }
      }
      &:nth-child(1),
      &:nth-child(3) {
        div {
          aspect-ratio: 0.69 / 1;
        }
      }
      &:nth-child(2) {
        div {
          aspect-ratio: 0.86 / 1;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .info {
      strong {
        font-size: 35px;
      }
      p {
        font-size: 18px;
      }
    }
    .introduce {
      .inner {
        height: 400px;
      }
      .company {
        padding-top: 250px;
      }
    }
    .products {
      .item {
        padding: 20px;
        &:hover {
          box-shadow: none;
          background: #f6f6f6;
        }
      }
    }
    .portfolio .column {
      &:nth-child(1),
      &:nth-child(2) {
        div {
          aspect-ratio: 0.69 / 1;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .info {
      margin: 0 auto 40px;
      strong {
        font-size: 29px;
      }
      p {
        margin-top: 10px;
        font-size: 15px;
      }
    }
    > div {
      margin-bottom: 20px;
    }
    .introduce {
      .inner {
        margin-top: 0;
        height: 400px;
        margin-bottom: 198px;
        font-size: 15px;
      }
      .company {
        padding-top: 200px;
      }
    }
    .portfolio .column div:not(:last-child) {
      margin-bottom: 30px;
    }
    .products {
      margin: 50px 0;
      img {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
`;

export const ModernBannerContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  aspect-ratio: 3.2 / 1;
  &.expanded {
    aspect-ratio: auto;
    height: calc(100vh - 195px);
    /* aspect-ratio: 2.2 / 1; */
  }
  > button {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 50%;
    background: rgba(128, 128, 128, 0.5);
    z-index: 10;
    font-size: 36px;
    color: #fff;
    transform: translateY(-50%);
    border: none;
    svg {
      display: block;
      margin: auto;
    }
    polyline {
      stroke: #fff;
    }
    &.prev {
      left: 0;
      border-radius: 0 10px 10px 0;
    }
    &.next {
      right: 0;
      border-radius: 10px 0 0 10px;
    }
  }
  .banners,
  .bannerSlide {
    width: 100%;
    height: 100%;
  }
  .bannerSlide {
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      user-select: none;
      opacity: 1;
    }
  }
  @media screen and (max-width: 1050px) {
    width: 100%;
    > button {
      width: 60px;
      height: 60px;
      font-size: 24px;
    }
  }
  @media screen and (max-width: 767px) {
    aspect-ratio: 1.3 / 1;
    &.expanded {
      aspect-ratio: 1.3 / 1;
      height: auto;
    }
    > button {
      width: 45px;
      height: 45px;
      font-size: 18px;
    }
  }
`;
